import api from '../config/api';

const shippingZoneService = {
  async getAll() {
    const response = await api.get('/api/admin/shipping-zones');
    return response.data;
  },

  async updatePrice(id, price) {
    const response = await api.post(`/api/admin/shipping-zones/${id}/update-price`, { price });
    return response.data;
  },

  async create(nameEn, nameAr, price) {
    const response = await api.post('/api/admin/shipping-zones/create', { nameEn, nameAr, price });
    return response.data;
  },
};

export default shippingZoneService;
